import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { pageGenerator } from '../PageContent';
import Navigation from '../../Navigation';
import * as ProjectSelectors from 'store/project/projectSelectros';

export default function PageRoutes() {
  const projectTypeActive = useSelector(ProjectSelectors.selectProjectsTypeActive);
  const projectsTypes = useSelector(ProjectSelectors.selectProjectsTypes);
  const projectsDetails = useSelector(ProjectSelectors.selectProjectsDetails);
  const projectsNavigation = useSelector(ProjectSelectors.selectProjectsNavigation);
  const projects = pageGenerator(projectsTypes);

  return (
    <Router>
      <Navigation items={projectsNavigation} />
      <Routes>
        {projectTypeActive && projectsTypes.map(projectType => {
          return (
            <Route
              exact
              key={projectType}
              path={projectsDetails[projectType].linkPathParent + projectsDetails[projectType].linkPath}
              element={projects[projectType]}>
              {projectsDetails[projectType]?.checklistTabs?.map((checklistTab) => (
                <Route
                  exact
                  key={checklistTab.id}
                  path={checklistTab.link}
                  element={projects[projectType]} />
              )) || []}
            </Route>
          )
        })}
      </Routes>
    </Router>
  );
}
